export default __webpack_public_path__ + "static/media/error-page-bg.6137fa59.svg";